import { RadioGroup } from '@headlessui/react';
import { get } from 'lodash';
import React from 'react';
import { cn } from '@shared/ui';

interface AccountProps {
    account: {
        carrier: string;
        firstName?: string;
        lastName?: string;
        email?: string;
    };
    carrier: {
        id: string;
        name: string;
        hasImage?: boolean;
    };
    onClick?: () => void;
}

const Account: React.FC<AccountProps> = ({ account, carrier, onClick }) => {
    const fullName = [account.firstName, account.lastName]
        .filter(Boolean)
        .join(' ');

    // Use the same logic for carrier images as in Carrier.js
    const logoBucket = "https://axle-labs-assets.s3.amazonaws.com/carrierLogos/";
    const carrierImage = carrier.hasImage
        ? logoBucket + carrier.id + ".svg"
        : logoBucket + "generic.svg";

    return (
        <RadioGroup.Option
            onClick={onClick}
            key={carrier.id}
            value={account}
            className={({ checked }) =>
                cn(
                    "flex cursor-pointer items-center gap-4 rounded-lg border p-4 text-ink transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2",
                    checked
                        ? "border-ink bg-surface-muted shadow-[inset_0_0_0_1px_rgb(var(--ax-ink))]"
                        : "border-border hover:bg-canvas"
                )
            }
        >
            {({ checked }) => (
                <>
                    <div
                        style={{
                            backgroundImage: `url("${carrierImage}")`,
                        }}
                        className="size-11 shrink-0 rounded-full border border-subtle bg-surface bg-cover bg-center"
                        aria-label={carrier.name}
                    ></div>
                    <div className="min-w-0 flex-grow">
                        <h2 className="text-body-lg font-medium">{carrier.name}</h2>
                        {/* If account email is available, use that. If not, use user firstName */}
                        {account.email
                            ? <p className="truncate text-body-lg text-ink-secondary">{account.email}</p>
                            : (account.firstName || account.lastName) && (
                                <p className="truncate text-body-lg text-ink-secondary">
                                    {[account.firstName, account.lastName].filter(Boolean).join(' ')}
                                </p>
                            )
                        }
                    </div>
                    <span
                        aria-hidden
                        className={cn(
                            "flex size-5 shrink-0 items-center justify-center rounded-full border",
                            checked ? "border-ink" : "border-border"
                        )}
                    >
                        {checked ? <span className="size-2.5 rounded-full bg-ink" /> : null}
                    </span>
                </>
            )}
        </RadioGroup.Option>
    );
};

export default Account;